import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
} from "react-bootstrap";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import axiosInstance from "../../Utils/axiosInstance";

const BrokerAge = () => {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axiosInstance.get("/paper-app/brokerage-report/");
        if (res.data?.status === "success") {
          setRows(res.data.data);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Extract all keys from first row
  const allKeys = rows.length > 0 ? Object.keys(rows[0]) : [];

  // (Optional) Totals row — you can compute this dynamically if needed
  // For now just leaving blank for keys (or compute sums)
  const totalsRow: { [key: string]: string } = {};
  allKeys.forEach((key) => {
    totalsRow[key] = rows[0]?.[key] ?? "-"; // Replace with your actual total logic
  });

  // Filter logic per column
  const filteredRows = rows.filter((row, rowIndex) =>
    allKeys.every((key) => {
      const filterVal = filters[key] || "";
      // skip totals row from filtering
      if (rowIndex === 0) return true;
      return String(row[key]).toLowerCase().includes(filterVal.toLowerCase());
    })
  );

  // Handle per-column filter change
  const handleFilterChange = (key: string, value: string) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div className="page-body">
      <Accordion defaultActiveKey="0" className="table-ad__addInputs">
        <AccordionItem eventKey="0">
          <AccordionHeader className="accordion_button">
            Brokerage
          </AccordionHeader>
          <AccordionBody>
            <div className="form_contain">
              <div
                className="flex formWrapper"
                style={{ backgroundColor: "#f8f9fa", padding: "10px" }}
              >
                {loading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: 200 }}
                  >
                    <Spinner animation="border" />
                  </div>
                ) : (
                  <div style={{ overflowX: "auto", maxHeight: 400 }}>
                    <Table
                      bordered
                      hover
                      size="sm"
                      responsive
                      className="table-striped table-sm align-middle text-center"
                      style={{
                        fontSize: "0.75rem",
                        borderCollapse: "collapse",
                        minWidth: "100%",
                      }}
                    >
                      <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                        {/* Row 1 — Totals Row */}
                        <tr style={{ background: "#dfe6f1", fontWeight: 700 }}>
                          {allKeys.map((key) => (
                            <th
                              key={key}
                              style={{
                                textTransform: "capitalize",
                                padding: "4px 6px",
                                borderBottom: "2px solid #c0c0c0",
                              }}
                            >
                              {key}
                            </th>
                          ))}
                        </tr>
                        <tr
                          style={{ background: "#b0c4de", fontWeight: "bold" }}
                        >
                          {allKeys.map((key) => (
                            <th key={key}>{totalsRow[key] ?? "-"}</th>
                          ))}
                        </tr>

                        {/* Row 2 — Column Names */}
                      </thead>

                      <tbody>
                        {/* Row 3 — Filters Row */}
                        <tr style={{ background: "#fafafa" }}>
                          {allKeys.map((key) => (
                            <td key={`filter-${key}`}>
                              <Form.Control
                                size="sm"
                                placeholder="Filter"
                                value={filters[key] || ""}
                                onChange={(e) =>
                                  handleFilterChange(key, e.target.value)
                                }
                                style={{
                                  fontSize: "0.65rem",
                                  padding: "2px 4px",
                                  height: 24,
                                }}
                              />
                            </td>
                          ))}
                        </tr>

                        {/* Data Rows (skip first one) */}
                        {filteredRows.length > 1 ? (
                          filteredRows.slice(1).map((row, idx) => (
                            <tr key={idx}>
                              {allKeys.map((key) => (
                                <td
                                  key={key}
                                  style={{
                                    padding: "4px 6px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {row[key]}
                                </td>
                              ))}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={allKeys.length}
                              style={{ textAlign: "center", padding: "10px" }}
                            >
                              No records found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                )}
              </div>
            </div>
          </AccordionBody>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default BrokerAge;
